import React from 'react'
import { Icon } from 'components/library'
import './Message.css'

const Message = props => {
  const classNames = ['Message']
  let icon = 'info'

  if(props.error) {
    classNames.push('is-error')
    icon = 'close'
  }

  if(props.success) {
    classNames.push('is-success')
    icon = 'check'
  }

  if(props.task) {
    classNames.push('is-task')
    icon = 'menu'
  }

  return (
    <div className={classNames.join(' ')} style={props.style}>
      <div className="Message-icon">
        <Icon name={props.icon || icon} />
      </div>

      {props.title &&
        <div className="Message-title">
          <b>{props.title}</b>
        </div>
      }

      {props.children}
    </div>
  )
}

export default Message



// WEBPACK FOOTER //
// ./src/components/library/message/Message.js